<template>
    <div  >
            <top-navbar></top-navbar>
    
    
            <div  class="mb-5  background_color " >
              <h6 class="manage-boder pt-2 font1  decoration"> <router-link class="decoration" to="/issuetracking/index"> {{language[1]['Home']}} </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><router-link class="decoration" to="/contractors/index">{{language[5]['Manage Contractor']}}  </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>{{language[53][' Create Contractor']}}   </h6>
                <!-- <h6 class="custom-maintitle mb-2"><b>Create Customer </b></h6> -->
                <div style=" padding-bottom: 100px;" class="container-fluid ">
                <div class="card bdr-rad2 mt-1 shadow p-2 ">
                <div class="card-body">


                    <form @submit.prevent="SaveProduct()" >

                      <div class="row">
                        <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;"> {{language[58]['Profile picture']}}</label>
        <input 
          type="file" 
          class="form-control font-size_def" 
          id="file" 
          name="file" 
          
          @change="handleFileUpload"  
        />
            
    </div>
  </div>
 <div class="col-md-3">
 <div class="form-group ">
         <label class="custom-label" style="font-size: small;">{{language[60]['Username']}}</label>
         <input  v-model="contractor.name"  style="font-size: small;" class="form-control bdr-rad" disabled>
        
 </div>
</div>
<div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">{{language[49]['First name']}} </label>
            <input  v-model="contractor.first_name"  style="font-size: small;" class="form-control bdr-rad" >
           
    </div>
  </div>
    <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">{{language[100]['Last name']}} </label>
            <input  v-model="contractor.last_name"  style="font-size: small;" class="form-control bdr-rad" >
         
    </div>
  </div>




</div>



<div class="row" >
<div class="col-md-3">
 <div class="form-group ">
         <label class="custom-label" style="font-size: small;">{{language[75]['Mobile']}}  </label>
         <input  v-model="contractor.mobile"  style="font-size: small;" class="form-control bdr-rad" :class="{'is-invalid': errors.mobile}">
         <div class="invalid-feedback">
           {{ errors.mobile }}
         </div>
 </div>
</div>
<div class="col-md-3">
 <div class="form-group ">
         <label class="custom-label" style="font-size: small;">{{language[76]['Email']}} </label>
         <input  v-model="contractor.email"  style="font-size: small;" class="form-control bdr-rad" disabled >
       
 </div>
</div>




 <div class="col-md-3">
 <div class="form-group ">
         <label class="custom-label" style="font-size: small;">{{ language[16]['Main Category'] }}</label>
       
         <v-select label="category_name"  v-model="contractor.main_category" :options="mainscats" :multiple="true" :class="{'is-invalid': errors.main_category}" ></v-select>
         <div class="invalid-feedback">
           {{ errors.main_category }}
         </div>
 </div>
</div>
 <div class="col-md-3">
 <div class="form-group ">
         <label class="custom-label" style="font-size: small;">{{ language[17]['Sub Category'] }}</label>
       
         <v-select label="category_name"  v-model="contractor.sub_category" :options="subcats" :multiple="true" :class="{'is-invalid': errors.sub_category}"></v-select>
         <div class="invalid-feedback">
           {{ errors.sub_category }}
         </div>
 </div>
</div>


</div>
















   

    <div style="border-bottom: 0px; padding-top: 0px;" class="navbar">
    
    <div class="d-flex  ">
    
    </div>
    <div class="d-flex  ">
        <button  type="submit" class="mr-1 btn btn-outline-primary  mb-1 font-size_def bdr-rad">{{language[78]['Update']}}</button>
    </div>
    </div>
    <br><br>


</form>




                </div>
                </div>
           
            </div>
           
          </div>
    
            <!-- <vue-select label="value" style="z-index: 999;" v-model="selectedOption" :options="options" ></vue-select> <br><br><br><br><br><br> -->
            <content-footer></content-footer>
    </div>
    </template>
    <script>
      import vSelect from 'vue-select';
      import 'vue-select/dist/vue-select.css';
     import axios from 'axios';
     import httpClient from '@/axios';
     import authService from '@/auth.service';
      import TopNavbar from './../../layout/TopNavbar.vue'
      import ContentFooter from './../../layout/ContentFooter.vue'
     
    
    
      export default {

        mounted(){
    this.loadCat()
      },
        data() {
          return {
            access_token:authService.isLoggedIn(),
            userid:authService.isUserid(),
            id:this.$route.query.id,
            language:JSON.parse(authService.isLanguage()),
        total:0,
        selectedOption: null, // Store the selected option
       

        errors: {},
        mainscats:[],
        subcats:[],
        contractor:{},
       
      
      
           
          }
    
        },
        components :{
          'v-select': vSelect,
            ContentFooter,
            TopNavbar,
           
        },

        methods : {
          validate(){
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const mobilePattern = /^\+46\d{2}\d{3}\d{4}$/; 
      this.errors = {};
      if(this.contractor.name == ''){
        this.$set(this.errors, 'name', "Contractor Name is required");
      }
      if(this.contractor.main_category == ''){
        this.$set(this.errors, 'main_category', "Work Type1 is required");
      }
      if(this.contractor.sub_category == ''){
        this.$set(this.errors, 'sub_category', "Work Type2 is required");
      }
      
      if (!emailPattern.test(this.contractor.email)) {
        this.$set(this.errors, 'email', "Please enter a valid email address");
      }
    
      if (!this.contractor.mobile) {
        this.$set(this.errors, 'mobile', "Mobile number is required");
    } else {
        try {
          const phoneNumber = libphonenumber.parsePhoneNumber(this.contractor.mobile, 'SE'); // 'SE' for Sweden

// Validate number and prefix
if (phoneNumber.isValid() && phoneNumber.country === 'SE') {
  const validPrefixes = ['4670', '4671', '4672', '4673', '4676', '4679'];
  const prefix = phoneNumber.number.slice(1, 5); // Extract "+467x"

  if (!validPrefixes.includes(prefix)) {
    addError('mobile', "Invalid Swedish mobile number.");
  }
} else {
  addError('mobile', "Please enter a valid mobile number");
}
        } catch (error) {
            this.$set(this.errors, 'mobile', "Please enter a valid mobile number");
        }
    }
  },

  handleFileUpload(event) {
            this.file = event.target.files[0];
        },



            async loadCat() {
    
    console.log(this.issue);
   
    try {
      const { data} = await  httpClient.get('/web/api/issuetracking/loadcat1',{
        headers:{
          'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);
       this.mainscats = data.mainscats;
       this.subcats = data.subcats;
       
      
    } catch (error) {
      console.log(error.response);
    }


    try {
      const { data} = await  httpClient.get('/web/api/contractors/loadalldata?id='+this.id,{
        headers:{
          'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);
       this.contractor = data.contractor;
      
       
      
    } catch (error) {
      console.log(error.response);
    }


  },

    async SaveProduct() {
       
      this.validate();
      if(Object.keys(this.errors).length === 0){

        const formData = new FormData();
      formData.append('userid', this.userid);
      formData.append("contractor", JSON.stringify(this.contractor)); 
       formData.append('file', this.file);
      
       try {
         const { data} = await  httpClient.post('/web/api/contractors/update?id='+this.id,formData,{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',
            
           }
          });
          console.log(data);
        if(data.status==200){
          this.$router.push('/contractors/index');
        }
          
           
         
       } catch (error) {
         console.log(error.response);
       }
      }
     },
       

     

    },
    
    }
    
    </script>

    <style scoped>
.vs__dropdown-toggle {
      border-radius: 10px !important;
    border-top-left-radius: 10px !important;
    border-top-right-radius: 10px !important;
    border-bottom-right-radius: 10px !important;

}

    </style>
    